import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import AuthRoute from 'src/views/authentication/auth/AuthRoute';
import RoleBasedRedirect from './RoleBasedRedirect';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const QuotesDashboardPage = Loadable(lazy(() => import('../views/quotes/QuotesDashboardPage')));
const ErrorPage = Loadable(lazy(() => import('../views/authentication/Error')));
const Register = Loadable(lazy(() => import('../views/authentication/Register')));
const Login = Loadable(lazy(() => import('../views/authentication/Login')));
const CreateUser = Loadable(lazy(() => import('../views/settings/create-user')));
const Info = Loadable(lazy(() => import('../views/settings/settings-info')));
const TermsSettings = Loadable(lazy(() => import('../views/settings/terms-settings')));
const ConfigSettings = Loadable(lazy(() => import('../views/settings/config-settings')));
const Quotes = Loadable(lazy(() => import('../views/quotes/quotes')));
const Product = Loadable(lazy(() => import('../views/product/product')));
const Leads = Loadable(lazy(()=> import('../views/leads/Leads')));
const Enquiry = Loadable(lazy(()=> import('../views/enquiry/Enquiry')));
const Customers = Loadable(lazy(() => import('../views/customer/customer.jsx')));
const Approvals = Loadable(lazy(() => import('../views/approvals/Approval.jsx')));

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', exact: true, element: <AuthRoute element={<RoleBasedRedirect />} /> },
      { path: 'dashboard', element: <AuthRoute element={<QuotesDashboardPage />} requiredRole='admin' /> },
      { path: 'product', element: <AuthRoute element={<Product />} requiredRole='admin' /> },
      { path: 'customers', element: <AuthRoute element={<Customers />} /> },
      { path: 'quotes', element: <AuthRoute element={<Quotes />} /> },
      { path: 'settings', element: <Navigate to='/settings/info' replace /> },
      { path: 'settings/createUser', element: <AuthRoute element={<CreateUser />} requiredRole='admin' />},
      { path: 'settings/info', element: <AuthRoute element={<Info />} /> },
      { path: 'settings/terms', element: <AuthRoute element={<TermsSettings />} /> },
      { path: 'settings/config', element: <AuthRoute element={<ConfigSettings />} requiredRole='admin' /> },
      { path: 'leads', element: <AuthRoute element={<Leads />} /> },
      { path: 'enquiry', element: <AuthRoute element={<Enquiry />} /> },
      { path: 'approvals', element: <AuthRoute element={<Approvals />} /> },
      { path: '*', element: <Navigate to='/auth/404' /> }
    ]
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: '404', element: <ErrorPage /> },
      { path: '*', element: <Navigate to='/auth/404' /> }
    ]
  }
]


export default Router;
